const isLinkRegex = new RegExp(/^(http|https):\/\/[^\s/$.?#].[^\s]*$/i);

export {
  isLinkRegex
};